const HomeFeature = () => {
  return (
    <>
      {/* FEATURE AREA START ( Feature - 3) */}
      <div className="ltn__feature-area section-bg-1 mt-90 pt-30 pb-30 mt--65---">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__feature-item-box-wrap ltn__feature-item-box-wrap-2 ltn__border--- section-bg-1">
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/8-trolley.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>Free shipping</h4>
                    <p>On all orders over $49.00</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/9-money.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>15 days returns</h4>
                    <p>Moneyback guarantee</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/10-credit-card.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>Secure checkout</h4>
                    <p>Protected by Paypal</p>
                  </div>
                </div>
                <div className="ltn__feature-item ltn__feature-item-8">
                  <div className="ltn__feature-icon">
                    <img src="img/icons/svg/11-gift-card.svg" alt="#" />
                  </div>
                  <div className="ltn__feature-info">
                    <h4>Offer &amp; gift here</h4>
                    <p>On all orders over</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* FEATURE AREA END */}
    </>
  );
};

export default HomeFeature;
